import { render } from "./Parametres.vue?vue&type=template&id=346af292&scoped=true"
import script from "./Parametres.vue?vue&type=script&lang=js"
export * from "./Parametres.vue?vue&type=script&lang=js"

import "./Parametres.vue?vue&type=style&index=0&id=346af292&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-346af292"]])

export default __exports__